import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Button, ButtonGroup } from "reactstrap";
import { BarLoader } from "react-spinners";
import Swal from "sweetalert2";
import Files from "react-butterfiles";
import { deletePersonalDocument } from "./Axios";
import FieldWrapper from "../../commons/FieldWrapper";
import axios from "axios";

const AdminPersonalDocumentForm = ({ descriptor, stageId, personalDocument }) => {
  const [document, setDocument] = useState(personalDocument || {}); // ✅ Inicializa el estado

  const [uploadErrors, setUploadErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
      setDocument(personalDocument || {}); // ✅ Actualiza cuando cambian las props
  }, [personalDocument]);

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };

  const uploadFile = async (files) => {
    setUploadErrors([]);

    if (files.length === 0) return;

    const file = files[0].src.file;

    // Validar tamaño (5MB máximo)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      setUploadErrors([`El archivo es demasiado grande (${(file.size / 1024 / 1024).toFixed(2)}MB). El tamaño máximo permitido es 5MB.`]);
      setTimeout(() => setLoading(false), 1000);
      return;
    }

    try {
      setLoading(true);

      // Convertir archivo a Base64
      const base64 = await fileToBase64(file);

      // Preparar datos JSON
      const documentData = {
        personal_document: {
          document_descriptor_id: descriptor.id,
          document_base64: base64,
          document_filename: file.name,
          document_content_type: file.type
        },
        stage_id: stageId
      };

      if (document.id) {
        documentData.personal_document.id = document.id;
      }

      axios.post("/api/admin_personal_documents", documentData, {
        headers: {
          "X-CSRF-TOKEN": window.Hupe8.token,
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        console.log("✅ Documento subido:", response.data);
        setDocument(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error al subir documento:", error);
        // Si hay un mensaje específico del backend (virus detectado, etc.), usarlo
        const errorMessage = error.response?.data?.message ||
                             error.response?.data?.error ||
                             "Error al subir el documento";
        setUploadErrors([errorMessage]);
        setLoading(false);
      });
    } catch (error) {
      setUploadErrors([error.message || "Error al procesar el archivo"]);
      setLoading(false);
    }
  };

  const deleteFile = () => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "El archivo se eliminará, pero podrás subir otro.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar"
    }).then(result => {
      if (result.isConfirmed) {
        axios.delete(`/api/admin_personal_documents/${document.id}/destroy_document`, {
          headers: { "X-CSRF-TOKEN": window.Hupe8.token }
        })
        .then(response => {
          setDocument({ ...document, document: null });
          Swal.fire("Eliminado", response.data.message, "success");
        })
        .catch(() => {
          Swal.fire("Error", "No se pudo eliminar el archivo", "error");
        });
      }
    });
  };


  const setErrors = errors => {
    setLoading(true);
    const newErrors = errors.map(error => {
      if (error.type === "unsupportedFileType") return "Formato no permitido";
      if (error.type === "maxSizeExceeded") return "Tamaño máximo excedido (2 MB)";
      return "Error al subir";
    });
    setTimeout(() => setLoading(false), 1000);
    setUploadErrors(newErrors);
  };

  return (
    <Row className="mb-5 align-middle">
     <Col xs="10" lg="6" md="6">
        <div className="media d-flex align-items-center">
          <i className={`far fa-file fa-3x mr-3 mt-1 ${document.document ? "text-success" : ""}`} />
          <div className="media-body ms-3">
            <h4 className={`mt-1 mb-0 fs-6 fw-bold ${document.document ? "text-success" : ""}`}>
              {descriptor.name}
            </h4>
            {document.document && (
              <p className="small text-success mb-1">
                Documento subido correctamente.
              </p>
            )}
            <div className="sweet-loading text-center mt-3">
              <BarLoader color={"#123abc"} loading={loading} height="10" width="300" />
            </div>
            <FieldWrapper errors={uploadErrors} />
          </div>
        </div>
      </Col>
      <Col xs="12" sm="12" md="6" lg="6" className="mt-3 text-lg-right button-group-container">
        <Files
          multiple={false}
          maxSize="2mb"
          accept={descriptor.allowed_file_types}
          onSuccess={files => uploadFile(files)}
          onError={errors => setErrors(errors)}
        >
          {({ browseFiles }) => (
            <div className="button-group">
              {document.document ? (
                <Fragment>
                  <Button color="success" outline size="sm" onClick={browseFiles}>
                    Actualizar
                  </Button>
                  <Button color="info" outline size="sm" href={document.document} target="_blank" rel="noopener noreferrer">
                    Descargar
                  </Button>
                  <Button color="danger" outline size="sm" onClick={deleteFile}>
                    Eliminar
                  </Button>
                </Fragment>
              ) : (
                <Button color="success" outline size="sm" onClick={browseFiles}>
                  Subir Documento
                </Button>
              )}
            </div>
          )}
        </Files>
      </Col> 
    </Row>
  );
};

export default AdminPersonalDocumentForm;

